import { render, staticRenderFns } from "./CoffeeList.vue?vue&type=template&id=8391c9b8&scoped=true&lang=html&"
import script from "./CoffeeList.vue?vue&type=script&lang=js&"
export * from "./CoffeeList.vue?vue&type=script&lang=js&"
import style0 from "./CoffeeList.vue?vue&type=style&index=0&id=8391c9b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8391c9b8",
  null
  
)

export default component.exports